import { Card, Notice } from "../components/ui";

/** Relative to index.html, so it resolves from any subpath / IPFS gateway (hash routing keeps the
 *  document URL at the bundle location). Served from frontend/public/. */
const PDF_URL = "whitepaper-v2.pdf";

export function Whitepaper() {
  return (
    <>
      <div className="section-title">Whitepaper</div>
      <Card
        title="basedAI Whitepaper v2"
        sub="Fee-for-service decentralized inference — the full protocol design."
        right={
          <div className="row">
            <a className="btn ghost sm" href={PDF_URL} target="_blank" rel="noreferrer">
              Open in new tab
            </a>
            <a className="btn sm" href={PDF_URL} download="basedAI-whitepaper-v2.pdf">
              Download PDF
            </a>
          </div>
        }
      >
        <object className="pdf-frame" data={PDF_URL} type="application/pdf" aria-label="basedAI whitepaper PDF">
          <Notice>
            Your browser can&apos;t display PDFs inline.{" "}
            <a href={PDF_URL} target="_blank" rel="noreferrer">
              Open the whitepaper in a new tab
            </a>{" "}
            or use the download button above.
          </Notice>
        </object>
      </Card>
    </>
  );
}
